/**
 * 使用范围
 * 车辆管理->竞价中/结标中,处理详情
 * */
import { createStore } from '@souche-f2e/muji';
import API from '@/services';
import { notification } from 'antd';
export default createStore({
    state: {
        carInfo: {},
    },
    effects: {
        /**
         * 处理详情 车辆基本信息
         * @param params
         */
        getCarInfo(params) {
            API.auction.getRealtimeCarDetails(params)
                .then((res) => {
                this.SET_STATE({ carInfo: res });
            });
        },
        /**
         * 取消报价
         * @param params
         */
        cancelBid(params) {
            const { bidId, id, callback } = params;
            API.auction.cancelBid({ bidId }).then((res) => {
                if (res) {
                    notification.success({
                        message: '取消报价成功',
                    });
                    // 刷新车辆基本信息
                    const param2 = {
                        auctionId: id
                    };
                    this.getCarInfo(param2);
                    callback && callback();
                }
            });
        },
    },
    reducers: {
        SET_STATE(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (typeof payload[key] !== 'undefined') {
                    state[key] = payload[key];
                }
            });
        },
    },
});
